<template>
  <div>
    <h1>403 Forbidden</h1>
  </div>
</template>

<script>
export default {
  mounted() {
  },
}
</script>
